import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

const Home = () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
const Register = () => import(/* webpackChunkName: "Register" */ '../views/Register/register.vue')
const UserAgreement = () => import(/* webpackChunkName: "UserAgreement" */ '../views/Register/userAgreement.vue')
const PrivacyAgreement = () => import(/* webpackChunkName: "PrivacyAgreement" */ '../views/Register/privacyAgreement.vue')
const Login = () => import(/* webpackChunkName: "Login" */ '../views/Login/login.vue')
const WeChatCallback = () => import(/* webpackChunkName: "WeChatCallback" */ '../views/Login/weChatCallback.vue')
const WeiboCallback = () => import(/* webpackChunkName: "WeiboCallback" */ '../views/Login/weiboCallback.vue')
const Im = () => import(/* webpackChunkName: "Im" */ '../views/Im/im.vue')
const LiveApply = () => import(/* webpackChunkName: "LiveApply" */ '../views/Apply/liveApply.vue')
const ArticleApply = () => import(/* webpackChunkName: "ArticleApply" */ '../views/Apply/articleApply.vue')
const ArticleDetail = () => import(/* webpackChunkName: "ArticleDetail" */ '../views/Apply/articleDetail.vue')
const VideoApply = () => import(/* webpackChunkName: "VideoApply" */ '../views/Apply/videoApply.vue')
const TrainApply = () => import(/* webpackChunkName: "TrainApply" */ '../views/Apply/trainApply.vue')
const AllArticleDetails = () => import(/* webpackChunkName: "AllArticleDetails" */ '../views/Details/allArticleDetails.vue')
const AllVideoDetails = () => import(/* webpackChunkName: "AllVideoDetails" */ '../views/Details/allVideoDetails.vue')
const ConciseList = () => import(/* webpackChunkName: "ConciseList" */ '../views/Other/conciseList.vue')
const Community = () => import(/* webpackChunkName: "Community" */ '../views/Community/communityIndex.vue')
const ReceptionLiveList = () => import(/* webpackChunkName: "ReceptionLiveList" */ '../views/Community/receptionLiveList.vue')
const ReceptionVideoList = () => import(/* webpackChunkName: "ReceptionVideoList" */ '../views/Community/receptionVideoList.vue')
const ReceptionDetail = () => import(/* webpackChunkName: "ReceptionDetail" */ '../views/Community/receptionDetail.vue')
const ReceptionAnchorDetails = () => import(/* webpackChunkName: "ReceptionAnchorDetails" */ '../views/Community/receptionAnchorDetails.vue')
const ReceptionPlaybackDetails = () => import(/* webpackChunkName: "ReceptionPlaybackDetails" */ '../views/Community/receptionPlaybackDetails.vue')
const ReceptionVideoDetail = () => import(/* webpackChunkName: "ReceptionVideoDetail" */ '../views/Community/receptionVideoDetail.vue')
const MemberList = () => import(/* webpackChunkName: "MemberList" */ '../views/Community/memberList.vue')
const MemberDetail = () => import(/* webpackChunkName: "MemberDetail" */ '../views/Community/memberDetail.vue')
const ActiveUserList = () => import(/* webpackChunkName: "ActiveUserList" */ '../views/Community/activeUserList.vue')
const CircleList = () => import(/* webpackChunkName: "CircleList" */ '../views/circle/circleList.vue')
const CirlePostList = () => import(/* webpackChunkName: "CirlePostList" */ '../views/circle/cirlePostList.vue')
const ExpertList = () => import(/* webpackChunkName: "ExpertList" */ '../views/Community/expertList.vue')
const ExpertDetail = () => import(/* webpackChunkName: "ExpertDetail" */ '../views/Community/expertDetail.vue')
const CommunityVideoList = () => import(/* webpackChunkName: "CommunityVideoList" */ '../views/Community/videoList.vue')
const UnionNav = () => import(/* webpackChunkName: "UnionNav" */ '../views/Union/unionNav.vue')
const UnionIntroduce = () => import(/* webpackChunkName: "UnionIntroduce" */ '../views/Union/unionIntroduce.vue')
const Union = () => import(/* webpackChunkName: "Union" */ '../views/Union/unionIndex.vue')
const DiscussList = () => import(/* webpackChunkName: "DiscussList" */ '../views/Union/discussList.vue')
const DiscussLiveDetail = () => import(/* webpackChunkName: "DiscussLiveDetail" */ '../views/Union/discussLiveDetail.vue')
const DiscussVideoDetail = () => import(/* webpackChunkName: "DiscussVideoDetail" */ '../views/Union/discussVideoDetail.vue')
const TrainList = () => import(/* webpackChunkName: "TrainList" */ '../views/Union/trainList.vue')
const TrainDetail = () => import(/* webpackChunkName: "TrainDetail" */ '../views/Union/trainDetail.vue')
const ContactsList = () => import(/* webpackChunkName: "ContactsList" */ '../views/Union/contactsList.vue')
const RoadshowList = () => import(/* webpackChunkName: "RoadshowList" */ '../views/Union/roadshowList.vue')
const RoadshowDetail = () => import(/* webpackChunkName: "RoadshowDetail" */ '../views/Union/roadshowDetail.vue')
const CooperationList = () => import(/* webpackChunkName: "CooperationList" */ '../views/Union/cooperationList.vue')
const CooperationDetail = () => import(/* webpackChunkName: "CooperationDetail" */ '../views/Union/cooperationDetail.vue')
const ForumList = () => import(/* webpackChunkName: "ForumList" */ '../views/Union/forumList.vue')
const ForumDetail = () => import(/* webpackChunkName: "ForumDetail" */ '../views/Union/forumDetail.vue')
const WelfareList = () => import(/* webpackChunkName: "WelfareList" */ '../views/Union/welfareList.vue')
const WelfareDetail = () => import(/* webpackChunkName: "WelfareDetail" */ '../views/Union/welfareDetail.vue')
const FoundationList = () => import(/* webpackChunkName: "FoundationList" */ '../views/Union/foundationList.vue')
const FoundationDetail = () => import(/* webpackChunkName: "FoundationDetail" */ '../views/Union/foundationDetail.vue')
const ResearchNav = () => import(/* webpackChunkName: "ResearchNav" */ '../views/Research/researchNav.vue')
const Research = () => import(/* webpackChunkName: "Research" */ '../views/Research/researchIndex.vue')
const ResearchIntroduce = () => import(/* webpackChunkName: "ResearchIntroduce" */ '../views/Research/researchIntroduce.vue')
const InternationalList = () => import(/* webpackChunkName: "InternationalList" */ '../views/Research/internationalList.vue')
const InternationalDetail = () => import(/* webpackChunkName: "InternationalDetail" */ '../views/Research/internationalDetail.vue')
const ObjectList = () => import(/* webpackChunkName: "ObjectList" */ '../views/Research/objectList.vue')
const ObjectDetail = () => import(/* webpackChunkName: "ObjectDetail" */ '../views/Research/objectDetail.vue')
const FindingsList = () => import(/* webpackChunkName: "FindingsList" */ '../views/Research/findingsList.vue')
const FindingsDetail = () => import(/* webpackChunkName: "FindingsDetail" */ '../views/Research/findingsDetail.vue')
const IndustryList = () => import(/* webpackChunkName: "IndustryList" */ '../views/Research/industryList.vue')
const IndustryDetail = () => import(/* webpackChunkName: "IndustryDetail" */ '../views/Research/industryDetail.vue')
const ReportList = () => import(/* webpackChunkName: "ReportList" */ '../views/Research/reportList.vue')
const ReportDetail = () => import(/* webpackChunkName: "ReportDetail" */ '../views/Research/reportDetail.vue')
const LearningList = () => import(/* webpackChunkName: "LearningList" */ '../views/Research/learningList.vue')
const LearningDetail = () => import(/* webpackChunkName: "LearningDetail" */ '../views/Research/learningDetail.vue')
const BookList = () => import(/* webpackChunkName: "BookList" */ '../views/Research/bookList.vue')
const BookDetail = () => import(/* webpackChunkName: "BookDetail" */ '../views/Research/bookDetail.vue')
const ScholarList = () => import(/* webpackChunkName: "ScholarList" */ '../views/Research/scholarList.vue')
const Personal = () => import(/* webpackChunkName: "Personal" */ '../views/User/personal.vue')
const MyDynamic = () => import(/* webpackChunkName: "MyDynamic" */ '../views/User/myDynamic.vue')
const AboutDynamic = () => import(/* webpackChunkName: "AboutDynamic" */ '../views/User/aboutDynamic.vue')
const LiveList = () => import(/* webpackChunkName: "LiveList" */ '../views/User/liveList.vue')
const ArticleList = () => import(/* webpackChunkName: "ArticleList" */ '../views/User/articleList.vue')
const UserVideoList = () => import(/* webpackChunkName: "UserVideoList" */ '../views/User/videoList.vue')
const DraftList = () => import(/* webpackChunkName: "DraftList" */ '../views/User/draftList.vue')
const MyUnion = () => import(/* webpackChunkName: "MyUnion" */ '../views/User/myUnion.vue')
const MyResearch = () => import(/* webpackChunkName: "MyResearch" */ '../views/User/myResearch.vue')
const FollowList = () => import(/* webpackChunkName: "FollowList" */ '../views/User/followList.vue')
const FansList = () => import(/* webpackChunkName: "FansList" */ '../views/User/fansList.vue')
const CollectList = () => import(/* webpackChunkName: "CollectList" */ '../views/User/collectList.vue')
const CommentList = () => import(/* webpackChunkName: "CommentList" */ '../views/User/commentList.vue')
const MyCircleList = () => import(/* webpackChunkName: "MyCircleList" */ '../views/User/myCircleList.vue')
const JoinCircleList = () => import(/* webpackChunkName: "JoinCircleList" */ '../views/User/joinCircleList.vue')
const PersonalData = () => import(/* webpackChunkName: "PersonalData" */ '../views/User/personalData.vue')
const EditPassWord = () => import(/* webpackChunkName: "EditPassWord" */ '../views/User/editPassWord.vue')
const AccountSecurity = () => import(/* webpackChunkName: "AccountSecurity" */ '../views/User/accountSecurity.vue')
const PersonalCertification = () => import(/* webpackChunkName: "PersonalCertification" */ '../views/User/personalCertification.vue')
const AnchorCertification = () => import(/* webpackChunkName: "AnchorCertification" */ '../views/User/anchorCertification.vue')
const LawyerCertification = () => import(/* webpackChunkName: "LawyerCertification" */ '../views/User/lawyerCertification.vue')
const CompanyCertification = () => import(/* webpackChunkName: "CompanyCertification" */ '../views/User/companyCertification.vue')
const PersonalCenter = () => import(/* webpackChunkName: "PersonalCenter" */ '../views/Personal/personalCenter.vue')
const None = () => import(/* webpackChunkName: "None" */ '../views/Other/none.vue')
const SearchList = () => import(/* webpackChunkName: "SearchList" */ '../views/Other/searchList.vue')
const UserGuide = () => import(/* webpackChunkName: "UserGuide" */ '../views/Other/userGuide.vue')
const Down = () => import(/* webpackChunkName: "Down" */ '../views/Other/down.vue')
const Feedback = () => import(/* webpackChunkName: "Feedback" */ '../views/Other/feedback.vue')
const IndexM = () => import(/* webpackChunkName: "IndexM" */ '../views/Mobile/indexM.vue')
const DetailM = () => import(/* webpackChunkName: "DetailM" */ '../views/Mobile/detailM.vue')
Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '绿盟平台',
      isMobile: false
    }
  },
  // 注册路由
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册',
      isMobile: false
    }
  },
  // 用户协议
  {
    path: '/userAgreement',
    name: 'UserAgreement',
    component: UserAgreement,
    meta: {
      title: '用户协议',
      isMobile: false
    }
  },
  // 隐私协议
  {
    path: '/privacyAgreement',
    name: 'PrivacyAgreement',
    component: PrivacyAgreement,
    meta: {
      title: '隐私协议',
      isMobile: false
    }
  },
  // 登陆路由
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录',
      isMobile: false
    }
  },
  // 微信绑定回调页面
  {
    path: '/weChatCallback',
    name: 'WeChatCallback',
    component: WeChatCallback,
    meta: {
      title: '微信绑定',
      isMobile: false
    }
  },
  // 微博绑定回调页面
  {
    path: '/weiboCallback',
    name: 'WeiboCallback',
    component: WeiboCallback,
    meta: {
      title: '微博绑定',
      isMobile: false
    }
  },
  // 即时通讯
  {
    path: '/im',
    name: 'Im',
    component: Im,
    meta: {
      title: '消息',
      isMobile: false
    }
  },
  // 发布直播
  {
    path: '/liveApply',
    name: 'LiveApply',
    component: LiveApply,
    meta: {
      title: '发布直播',
      isMobile: false
    }
  },
  // 发布文章
  {
    path: '/articleApply',
    name: 'ArticleApply',
    component: ArticleApply,
    meta: {
      title: '发布文章',
      isMobile: false
    }
  },
  // 草稿文章详情
  {
    path: '/articleDetail/:id',
    name: 'ArticleDetail',
    component: ArticleDetail,
    meta: {
      title: '详情',
      isMobile: false
    }
  },
  // 发布视频
  {
    path: '/videoApply',
    name: 'VideoApply',
    component: VideoApply,
    meta: {
      title: '发布视频',
      isMobile: false
    }
  },
  // 发布培训
  {
    path: '/trainApply',
    name: 'TrainApply',
    component: TrainApply,
    meta: {
      title: '发布培训',
      isMobile: false
    }
  },
  // 全部文章详情
  {
    path: '/allArticleDetails',
    name: 'AllArticleDetails',
    component: AllArticleDetails,
    meta: {
      title: '详情',
      isMobile: false
    }
  },
  // 全部视频详情
  {
    path: '/allVideoDetails',
    name: 'AllVideoDetails',
    component: AllVideoDetails,
    meta: {
      title: '详情',
      isMobile: false
    }
  },
  // 热搜列表
  {
    path: '/conciseList',
    name: 'ConciseList',
    component: ConciseList,
    meta: {
      title: '推荐',
      isMobile: false
    }
  },
  // 社区生态路由
  {
    path: '/community',
    name: 'Community',
    component: Community,
    meta: {
      title: '社区生态',
      parent: 1,
      isMobile: false
    }
  },
  // 专家学者会客厅/行业精英工作室/专业精英工作室 列表直播路由
  {
    path: '/receptionLiveList',
    name: 'ReceptionLiveList',
    component: ReceptionLiveList,
    meta: {
      title: '直播列表',
      isMobile: false
    }
  },
  // 会客厅列表回放路由
  {
    path: '/receptionVideoList',
    name: 'ReceptionVideoList',
    component: ReceptionVideoList,
    meta: {
      title: '精彩回放',
      isMobile: false
    }
  },
  // 会客厅详情
  {
    path: '/receptionDetail/:id',
    name: 'ReceptionDetail',
    component: ReceptionDetail,
    meta: {
      title: '会客厅详情',
      isMobile: false
    }
  },
  // 直播主播端详情
  {
    path: '/receptionAnchorDetails/:liveId/:listId',
    name: 'ReceptionAnchorDetails',
    component: ReceptionAnchorDetails,
    meta: {
      title: '个人中心',
      isMobile: false
    }
  },
  // 直播主播端详情
  {
    path: '/receptionPlaybackDetails/:liveId/:listId',
    name: 'ReceptionPlaybackDetails',
    component: ReceptionPlaybackDetails,
    meta: {
      title: '个人中心',
      isMobile: false
    }
  },
  // 会客厅 - 视频回顾详情
  {
    path: '/receptionVideoDetail/:id',
    name: 'ReceptionVideoDetail',
    component: ReceptionVideoDetail,
    meta: {
      title: '回顾',
      isMobile: false
    }
  },
  // 社区交流室列表
  {
    path: '/memberList',
    name: 'MemberList',
    component: MemberList,
    meta: {
      title: '社区交流室',
      isMobile: false
    }
  },
  // 社区交流室详情
  {
    path: '/memberDetail/:id',
    name: 'MemberDetail',
    component: MemberDetail,
    meta: {
      title: '社区交流室',
      isMobile: false
    }
  },
  // 活跃用户列表
  {
    path: '/activeUserList',
    name: 'ActiveUserList',
    component: ActiveUserList,
    meta: {
      title: '用户列表',
      isMobile: false
    }
  },
  // 圈子列表
  {
    path: '/circleList',
    name: 'CircleList',
    component: CircleList,
    meta: {
      title: '圈子',
      isMobile: false
    }
  },
  // 圈子帖子列表
  {
    path: '/cirlePostList/:id',
    name: 'CirlePostList',
    component: CirlePostList,
    meta: {
      title: '帖子列表',
      isMobile: false
    }
  },
  // 专家观点列表
  {
    path: '/expertList',
    name: 'ExpertList',
    component: ExpertList,
    meta: {
      title: '专家观点',
      isMobile: false
    }
  },
  // 专家观点详情
  {
    path: '/expertDetail/:id',
    name: 'ExpertDetail',
    component: ExpertDetail,
    meta: {
      title: '专家观点',
      isMobile: false
    }
  },
  // 视频列表
  {
    path: '/videoList',
    name: 'CommunityVideoList',
    component: CommunityVideoList,
    meta: {
      title: '视频',
      isMobile: false
    }
  },
  // 联盟生态 - 导航入口
  {
    path: '/unionNav',
    name: 'UnionNav',
    component: UnionNav,
    meta: {
      title: '联盟生态',
      parent: 2,
      isMobile: false
    }
  },
  // 联盟生态 - 联盟简介
  {
    path: '/unionIntroduce',
    name: 'UnionIntroduce',
    component: UnionIntroduce,
    meta: {
      title: '联盟生态',
      parent: 2,
      isMobile: false
    }
  },
  // 联盟生态 - 首页
  {
    path: '/union/:id',
    name: 'Union',
    component: Union,
    meta: {
      title: '联盟生态',
      parent: 2,
      isMobile: false
    }
  },
  // 联盟生态 - 研讨沙龙
  {
    path: '/discussList',
    name: 'DiscussList',
    component: DiscussList,
    meta: {
      title: '研讨沙龙',
      isMobile: false
    }
  },
  // 联盟生态 - 研讨沙龙直播详情
  {
    path: '/discussLiveDetail/:id',
    name: 'DiscussLiveDetail',
    component: DiscussLiveDetail,
    meta: {
      title: '直播详情',
      isMobile: false
    }
  },
  // 联盟生态 - 研讨沙龙视频详情
  {
    path: '/discussVideoDetail/:id',
    name: 'DiscussVideoDetail',
    component: DiscussVideoDetail,
    meta: {
      title: '回顾详情',
      isMobile: false
    }
  },

  // 联盟生态 - 培训列表
  {
    path: '/trainList',
    name: 'TrainList',
    component: TrainList,
    meta: {
      title: '培训列表',
      isMobile: false
    }
  },

  // 联盟生态 - 培训详情
  {
    path: '/trainDetail/:id',
    name: 'TrainDetail',
    component: TrainDetail,
    meta: {
      title: '培训详情',
      isMobile: false
    }
  },

  // 联盟生态 - 会员列表
  {
    path: '/contactsList',
    name: 'ContactsList',
    component: ContactsList,
    meta: {
      title: '企业列表',
      isMobile: false
    }
  },

  // 联盟生态 - 项目路演 - 列表
  {
    path: '/roadshowList',
    name: 'RoadshowList',
    component: RoadshowList,
    meta: {
      title: '项目路演',
      isMobile: false
    }
  },

  // 联盟生态 - 合作 - 列表
  {
    path: '/cooperationList',
    name: 'CooperationList',
    component: CooperationList,
    meta: {
      title: '合作',
      isMobile: false
    }
  },

  // 联盟生态 - 合作 - 详情
  {
    path: '/cooperationDetail/:id',
    name: 'CooperationDetail',
    component: CooperationDetail,
    meta: {
      title: '合作',
      isMobile: false
    }
  },

  // 联盟生态 - 项目路演 - 详情
  {
    path: '/roadshowDetail/:id',
    name: 'RoadshowDetail',
    component: RoadshowDetail,
    meta: {
      title: '项目路演',
      isMobile: false
    }
  },

  // 联盟生态 - 论坛 - 列表
  {
    path: '/forumList',
    name: 'ForumList',
    component: ForumList,
    meta: {
      title: '论坛',
      isMobile: false
    }
  },

  // 联盟生态 - 论坛 - 详情
  {
    path: '/forumDetail/:id',
    name: 'ForumDetail',
    component: ForumDetail,
    meta: {
      title: '论坛',
      isMobile: false
    }
  },

  // 联盟生态 - 公益项目 - 列表
  {
    path: '/welfareList',
    name: 'WelfareList',
    component: WelfareList,
    meta: {
      title: '公益项目',
      isMobile: false
    }
  },
  // 联盟生态 - 公益项目 - 详情
  {
    path: '/welfareDetail/:id',
    name: 'WelfareDetail',
    component: WelfareDetail,
    meta: {
      title: '公益项目',
      isMobile: false
    }
  },

  // 联盟生态 - 基金会 - 列表
  {
    path: '/foundationList',
    name: 'FoundationList',
    component: FoundationList,
    meta: {
      title: '基金会',
      isMobile: false
    }
  },
  // 联盟生态 - 基金会 - 详情
  {
    path: '/foundationDetail/:id',
    name: 'FoundationDetail',
    component: FoundationDetail,
    meta: {
      title: '基金会',
      isMobile: false
    }
  },

  // 研究院生态导航
  {
    path: '/researchNav',
    name: 'ResearchNav',
    component: ResearchNav,
    meta: {
      title: '研究院生态',
      parent: 3,
      isMobile: false
    }
  },
  // 研究院生态 - 研究院简介
  {
    path: '/researchIntroduce',
    name: 'ResearchIntroduce',
    component: ResearchIntroduce,
    meta: {
      title: '研究院简介',
      isMobile: false
    }
  },
  // 研究院生态路由
  {
    path: '/research/:id',
    name: 'Research',
    component: Research,
    meta: {
      title: '研究院生态',
      parent: 3,
      isMobile: false
    }
  },
  // 研究院生态 - 国际交流列表
  {
    path: '/internationalList',
    name: 'InternationalList',
    component: InternationalList,
    meta: {
      title: '国际交流',
      isMobile: false
    }
  },
  // 研究院生态 - 国际交流详情
  {
    path: '/internationalDetail/:id',
    name: 'InternationalDetail',
    component: InternationalDetail,
    meta: {
      title: '国际交流',
      isMobile: false
    }
  },
  // 研究院生态 - 项目合作列表
  {
    path: '/objectList',
    name: 'ObjectList',
    component: ObjectList,
    meta: {
      title: '项目合作',
      isMobile: false
    }
  },
  // 研究院生态 - 项目合作详情
  {
    path: '/objectDetail/:id',
    name: 'ObjectDetail',
    component: ObjectDetail,
    meta: {
      title: '项目合作',
      isMobile: false
    }
  },
  // 研究院生态 - 研究成果列表
  {
    path: '/findingsList/:id(\\d+)?',
    name: 'FindingsList',
    component: FindingsList,
    meta: {
      title: '研究成果',
      isMobile: false
    }
  },
  // 研究院生态 - 研究成果详情
  {
    path: '/findingsDetail/:id',
    name: 'FindingsDetail',
    component: FindingsDetail,
    meta: {
      title: '研究成果',
      isMobile: false
    }
  },
  // 研究院生态 - 行业手册列表
  {
    path: '/industryList',
    name: 'IndustryList',
    component: IndustryList,
    meta: {
      title: '行业手册',
      isMobile: false
    }
  },
  // 研究院生态 - 行业手册详情
  {
    path: '/industryDetail/:id',
    name: 'IndustryDetail',
    component: IndustryDetail,
    meta: {
      title: '行业手册',
      isMobile: false
    }
  },
  // 研究院生态 - 报告下载列表
  {
    path: '/reportList',
    name: 'ReportList',
    component: ReportList,
    meta: {
      title: '报告下载',
      isMobile: false
    }
  },
  // 研究院生态 - 报告下载详情
  {
    path: '/reportDetail/:id',
    name: 'ReportDetail',
    component: ReportDetail,
    meta: {
      title: '报告下载',
      isMobile: false
    }
  },
  // 研究院生态 - 学术交流列表
  {
    path: '/learningList/:id(\\d+)?',
    name: 'LearningList',
    component: LearningList,
    meta: {
      title: '学术交流',
      isMobile: false
    }
  },
  // 研究院生态 - 学术交流详情
  {
    path: '/learningDetail/:id',
    name: 'LearningDetail',
    component: LearningDetail,
    meta: {
      title: '学术交流',
      isMobile: false
    }
  },
  // 研究院生态 - 出版物列表
  {
    path: '/bookList',
    name: 'BookList',
    component: BookList,
    meta: {
      title: '出版物',
      isMobile: false
    }
  },
  // 研究院生态 - 出版物详情
  {
    path: '/bookDetail/:id',
    name: 'BookDetail',
    component: BookDetail,
    meta: {
      title: '出版物详情',
      isMobile: false
    }
  },
  // 联盟生态 - 专家学者列表
  {
    path: '/scholarList',
    name: 'ScholarList',
    component: ScholarList,
    meta: {
      title: '专家学者',
      isMobile: false
    }
  },
  // 个人中心
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: {
      title: '个人中心',
      isMobile: false
    },
    children: [
      { // 我的动态
        path: '/myDynamic',
        name: 'MyDynamic',
        component: MyDynamic,
        meta: {
          title: '我的动态',
          isMobile: false
        }
      },
      { // 关于我的
        path: '/aboutDynamic',
        name: 'AboutDynamic',
        component: AboutDynamic,
        meta: {
          title: '关于我的',
          isMobile: false
        }
      },
      { // 直播管理列表
        path: '/liveList',
        name: 'LiveList',
        component: LiveList,
        meta: {
          title: '直播管理',
          isMobile: false
        }
      },
      { // 文章管理列表
        path: '/articleList',
        name: 'ArticleList',
        component: ArticleList,
        meta: {
          title: '文章管理',
          isMobile: false
        }
      },
      { // 视频管理列表
        path: '/userVideoList',
        name: 'UserVideoList',
        component: UserVideoList,
        meta: {
          title: '视频管理',
          isMobile: false
        }
      },
      { // 草稿箱列表
        path: '/draftList',
        name: 'DraftList',
        component: DraftList,
        meta: {
          title: '草稿箱',
          isMobile: false
        }
      },
      { // 我的联盟
        path: '/myUnion',
        name: 'MyUnion',
        component: MyUnion,
        meta: {
          title: '我的关注',
          isMobile: false
        }
      },
      { // 我的研究院
        path: '/myResearch',
        name: 'MyResearch',
        component: MyResearch,
        meta: {
          title: '我的关注',
          isMobile: false
        }
      },
      { // 我的关注
        path: '/followList',
        name: 'FollowList',
        component: FollowList,
        meta: {
          title: '我的关注',
          isMobile: false
        }
      },
      { // 我的粉丝
        path: '/fansList',
        name: 'FansList',
        component: FansList,
        meta: {
          title: '我的粉丝',
          isMobile: false
        }
      },
      { // 收藏列表
        path: '/collectList',
        name: 'CollectList',
        component: CollectList,
        meta: {
          title: '收藏列表',
          isMobile: false
        }
      },
      { // 我的评论
        path: '/commentList',
        name: 'CommentList',
        component: CommentList,
        meta: {
          title: '我的评论',
          isMobile: false
        }
      },
      { // 我的圈子
        path: '/myCircleList',
        name: 'MyCircleList',
        component: MyCircleList,
        meta: {
          title: '我的圈子',
          isMobile: false
        }
      },
      { // 我加入的圈子
        path: '/joinCircleList',
        name: 'JoinCircleList',
        component: JoinCircleList,
        meta: {
          title: '我加入的圈子',
          isMobile: false
        }
      },
      { // 个人资料
        path: '/personalData',
        name: 'PersonalData',
        component: PersonalData,
        meta: {
          title: '编辑个人信息',
          isMobile: false
        }
      },
      { // 密码修改
        path: '/editPassWord',
        name: 'EditPassWord',
        component: EditPassWord,
        meta: {
          title: '密码修改',
          isMobile: false
        }
      },
      { // 账户管理
        path: '/accountSecurity',
        name: 'AccountSecurity',
        component: AccountSecurity,
        meta: {
          title: '账户管理',
          isMobile: false
        }
      },
      { // 实名认证
        path: '/personalCertification',
        name: 'PersonalCertification',
        component: PersonalCertification,
        meta: {
          title: '实名认证',
          isMobile: false
        }
      },
      { // 播主认证
        path: '/anchorCertification',
        name: 'AnchorCertification',
        component: AnchorCertification,
        meta: {
          title: '播主认证',
          isMobile: false
        }
      },
      { // 律师认证
        path: '/lawyerCertification',
        name: 'LawyerCertification',
        component: LawyerCertification,
        meta: {
          title: '律师认证',
          isMobile: false
        }
      },
      { // 企业认证
        path: '/companyCertification',
        name: 'CompanyCertification',
        component: CompanyCertification,
        meta: {
          title: '企业认证',
          isMobile: false
        }
      }
    ]
  },
  // 个人中心展示页面
  {
    path: '/personalCenter/:id',
    name: 'PersonalCenter',
    component: PersonalCenter,
    meta: {
      title: '个人中心',
      isMobile: false
    }
  },
  // 辅助页面404
  {
    path: '/none',
    name: 'None',
    component: None,
    meta: {
      title: '404',
      isMobile: false
    }
  },
  // 搜索页面
  {
    path: '/searchList/:val',
    name: 'SearchList',
    component: SearchList,
    meta: {
      title: '搜索',
      isMobile: false
    }
  },
  // 用户指引
  {
    path: '/userGuide',
    name: 'UserGuide',
    component: UserGuide,
    meta: {
      title: '用户指引',
      isMobile: false
    }
  },
  // 手机下载页面
  {
    path: '/down',
    name: 'Down',
    component: Down,
    meta: {
      title: '手机APP下载',
      isSuspensionRight: true,
      isMobile: false
    }
  },
  // 问题反馈页面
  {
    path: '/feedback',
    name: 'Feedback',
    component: Feedback,
    meta: {
      title: '问题反馈',
      isSuspensionRight: true,
      isMobile: false
    }
  },
  // 手机首页
  {
    path: '/indexM',
    name: 'IndexM',
    component: IndexM,
    meta: {
      title: '首页',
      isSuspensionRight: true,
      isMobile: true
    }
  },
  // 手机详情
  {
    path: '/detailM/:id',
    name: 'DetailM',
    component: DetailM,
    meta: {
      title: '详情',
      isSuspensionRight: false,
      isMobile: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 每次刷新页面后重新获取token值
store.commit('user/initUserInfo')
store.commit('initPersonalMeunAct')
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  // 路由变化修改title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 路由变化修改导航
  if (to.meta.parent) {
    sessionStorage.setItem('navId', to.meta.parent)
  }
  const token = localStorage.getItem('user')
  if (token === null) {
    if (to.path === '/circleList' || to.path === '/personal' || to.path === '/im') {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
    store.commit('other/editSmallbellNumber')
    store.commit('other/editUnreadMessage')
  }
  if (to.path === '/weChatCallback') {
    store.commit('user/initWeixinInfo')
  }
  if (to.path === '/weiboCallback') {
    store.commit('user/initWeiboInfo')
  }
})

export default router
